<owl-carousel-o [options]="customOptions">
  <ng-template carouselSlide>
    <div class="subscription-type bg-white rounded-10 shadow-sm p-3">
      <a routerLink="/expert-picks">
        <div class="row mx-0">
          <div class="col px-0">
            <h5 class="text-blue fw-bold">Expert Picks</h5>
            <p class="mb-0 small text-dark pe-2 pe-md-3">
              See which side proven sports bettors are on
            </p>
          </div>
          <div class="col-auto px-0 align-self-center">
            <img
              src="../../../../assets/icons/expert-picks.svg"
              alt="Expert Picks"
              class="img-fluid"
              width="52"
              height="52"
            />
          </div>
        </div>
      </a>
    </div>
  </ng-template>
  <ng-template carouselSlide>
    <div class="subscription-type bg-white rounded-10 shadow-sm p-3">
      <a routerLink="/top-bettors">
        <div class="row mx-0">
          <div class="col px-0">
            <h6 class="text-blue fw-bold">Top Experts</h6>
            <p class="mb-0 small text-dark pe-2 pe-md-3">
              Check all the top bettors and their picks
            </p>
          </div>
          <div class="col-auto px-0 align-self-center">
            <img
              src="../../../../assets/icons/expert-picks.svg"
              alt="Expert Picks"
              class="img-fluid"
              width="52"
              height="52"
            />
          </div></div
      ></a>
    </div>
  </ng-template>
  <ng-template carouselSlide>
    <div class="subscription-type bg-white rounded-10 shadow-sm p-3">
      <a routerLink="/place-picks">
        <div class="row mx-0">
          <div class="col px-0">
            <h6 class="text-blue fw-bold">Place Picks, Win Cash</h6>
            <p class="mb-0 small text-dark pe-2 pe-md-3">
              Place picks, get ranked and get paid, for FREE
            </p>
          </div>
          <div class="col-auto px-0 align-self-center">
            <img
              src="../../../../assets/icons/expert-picks.svg"
              alt="Expert Picks"
              class="img-fluid"
              width="52"
              height="52"
            />
          </div></div
      ></a>
    </div>
  </ng-template>
  <ng-template carouselSlide>
    <div class="subscription-type bg-white rounded-10 shadow-sm p-3">
      <a routerLink="/chat/latest">
        <div class="row mx-0">
          <div class="col px-0">
            <h6 class="text-blue fw-bold">Chat</h6>
            <p class="mb-0 small text-dark pe-2 pe-md-3">
              Live chat with proven sports bettors
            </p>
          </div>
          <div class="col-auto px-0 align-self-center">
            <img
              src="../../../../assets/icons/expert-picks.svg"
              alt="Expert Picks"
              class="img-fluid"
              width="52"
              height="52"
            />
          </div>
        </div>
      </a>
    </div>
  </ng-template>
</owl-carousel-o>
